import React from "react";
import { Button } from "@mui/material";
import { optionsEmailVerificado, optionsEstadoUsuarios, optionsTipo, optionsUserTester } from "../../../../constantes/constantes";
import { Download } from "@mui/icons-material";
import { Search, ChevronDown, X } from "lucide-react";



function FitroUserApps({
    nameCedula, handleNameCedula, email, handleEmail,
    estadoSelected, handleEstadoSearch, handleEstadoSelected,
    verificadoPorEmailSelected, handleVerificadoPorEmailSearch, handleVerificadoPorEmailSelected,
    tipoSelected, handleTipoSearch, handleTipoSelected,
    userTesterSelected, handleUserTester, handleUserTesterSelected

}) {


    return (
        <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
                <h2 className="text-xl font-semibold text-gray-800">Usuarios</h2>

                <Button
                    variant="contained"
                    startIcon={<Download />}
                    sx={{
                        backgroundColor: "#104063",
                        color: "#ffffff",
                        fontWeight: 700,
                        textTransform: "none",
                        borderRadius: "10px",
                        px: 2.5,
                        py: 1,
                        "&:hover": {
                            backgroundColor: "#0d3553",
                        },
                    }}
                >
                    Exportar
                </Button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="relative w-full">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <Search className="w-5 h-5" />
                    </span>
                    <input
                        type="text"
                        placeholder="Buscar por Nombre o Cedula"
                        value={nameCedula}
                        onChange={(e) => handleNameCedula(e.target.value)}
                        className="pl-10 pr-10 py-2 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm w-full focus:outline-none focus:ring-2 focus:ring-blue-200"
                    />
                    {nameCedula && (
                        <button
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            onClick={() => handleNameCedula("")}
                        >
                            <X className="w-5 h-5" />
                        </button>
                    )}
                </div>

                <div className="relative w-full">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <Search className="w-5 h-5" />
                    </span>
                    <input
                        type="text"
                        placeholder="Buscar por Email"
                        value={email}
                        onChange={(e) => handleEmail(e.target.value)}
                        className="pl-10 pr-10 py-2 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm w-full focus:outline-none focus:ring-2 focus:ring-blue-200"
                    />
                    {email && (
                        <button
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            onClick={() => handleEmail("")}
                        >
                            <X className="w-5 h-5" />
                        </button>
                    )}
                </div>

                <div className="relative w-full">
                    <select
                        value={estadoSelected?.value || "todos"}
                        onChange={(e) => {
                            const value = e.target.value;
                            handleEstadoSearch(value);
                            handleEstadoSelected(optionsEstadoUsuarios.find((option) => option.value === value) || null);
                        }}
                        className="appearance-none w-full px-3 py-2 pr-8 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
                    >
                        {optionsEstadoUsuarios.map((option) => (
                            <option key={option.id} value={option.value}>{`Estado: ${option.label}`}</option>
                        ))}
                    </select>
                    <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                </div>

                <div className="relative w-full">
                    <select
                        value={verificadoPorEmailSelected?.value || "todos"}
                        onChange={(e) => {
                            const value = e.target.value;
                            handleVerificadoPorEmailSearch(value);
                            handleVerificadoPorEmailSelected(optionsEmailVerificado.find((option) => option.value === value) || null);
                        }}
                        className="appearance-none w-full px-3 py-2 pr-8 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
                    >
                        {optionsEmailVerificado.map((option) => (
                            <option key={option.id} value={option.value}>{`Verificado por Email: ${option.label}`}</option>
                        ))}
                    </select>
                    <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                </div>

                <div className="relative w-full">
                    <select
                        value={tipoSelected?.value || "todos"}
                        onChange={(e) => {
                            const value = e.target.value;
                            handleTipoSearch(value);
                            handleTipoSelected(optionsTipo.find((option) => option.value === value) || null);
                        }}
                        className="appearance-none w-full px-3 py-2 pr-8 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
                    >
                        {optionsTipo.map((option) => (
                            <option key={option.id} value={option.value}>{`Tipo: ${option.label}`}</option>
                        ))}
                    </select>
                    <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                </div>

                <div className="relative w-full">
                    <select
                        value={userTesterSelected?.value || "todos"}
                        onChange={(e) => {
                            const value = e.target.value;
                            handleUserTester(value);
                            handleUserTesterSelected(optionsUserTester.find((option) => option.value === value) || null);
                        }}
                        className="appearance-none w-full px-3 py-2 pr-8 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
                    >
                        {optionsUserTester.map((option) => (
                            <option key={option.id} value={option.value}>{`Usuario Tester: ${option.label}`}</option>
                        ))}
                    </select>
                    <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                </div>
            </div>
        </div>
    )
}

export default FitroUserApps;